import React from 'react';
import { Container, Row, Col, Card, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faPhone, faList } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import './index.css';
import { faAppStoreIos, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const HomeRoute = () => {
    const navigate = useNavigate();

    const handleViewMenu = () => {
        navigate('/menu');
    };

    // const handleWhatsApp = () => {
    //     // Replace with actual WhatsApp number
    //     window.open('https://wa.me/1234567890', '_blank');
    // };

    const handleCallUs = () => {
        // Replace with actual phone number
        window.open('tel:+94114441333');
    };

    const handleAppStore = () => {
        // Replace with actual App Store link
        window.open('https://apps.apple.com/lk/app/curry-king/id6748001800', '_blank');
    };

    const handlePlayStore = () => {
        // Replace with actual Play Store link
        window.open('https://play.google.com/store/apps/details?id=com.curryking.app', '_blank');
    };

    return (
        <Container fluid className="home-route-container">
            <div className="hero-section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} className="text-center">
                            <h1 className="hero-title">Order Your Favorite Food</h1>
                            <p className="hero-subtitle">
                                Choose your preferred ordering method below for fast and convenient service
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Container className="ordering-options-section">
                <Row className="justify-content-center">
                    {/* Online Ordering */}
                    <Col lg={12} className="mb-4">
                        <Card className="online-ordering-card">
                            <div className="card-content">
                                <div className="icon-wrapper">
                                    <FontAwesomeIcon icon={faList} className="option-icon" />
                                </div>
                                <h3 className="option-title">Online Ordering</h3>
                                <p className="option-description">
                                    Browse our complete menu and place orders directly through our website with secure payment options.
                                </p>
                                <Button
                                    className="view-menu-btn"
                                    onClick={handleViewMenu}
                                >
                                    View Menu
                                </Button>
                            </div>
                        </Card>
                    </Col>
                </Row>

                <Row className="justify-content-center">
                    {/* Mobile Apps */}
                    <Col lg={6} md={6} className="mb-4">
                        <Card className="ordering-option-card">
                            <div className="card-content text-center">
                                <div className="icon-wrapper mx-auto mb-3" style={{ marginTop: '20px' }}>
                                    <FontAwesomeIcon icon={faMobileAlt} className="option-icon" />
                                </div>
                                <h4 className="option-title">Mobile Apps</h4>
                                <p className="option-description">
                                    Download our app for iOS or Android to order on the go with exclusive mobile offers and faster checkout.
                                </p>
                                    <div className='d-flex flex-column gap-2 align-items-center mt-3 flex-wrap'>
                                        <Button
                                            className="app-store-btn w-100 app-store-btn-custom"
                                            onClick={handleAppStore}
                                        >
                                            <div className="app-store-btn-inner">
                                                <FontAwesomeIcon icon={faAppStoreIos as IconProp} className='me-2 app-store-btn-icon' />
                                                <div className='d-flex flex-column text-start px-2'>
                                                    <span className="app-store-btn-small">Download on the</span>
                                                    <span className="app-store-btn-bold">App Store</span>
                                                </div>
                                            </div>
                                        </Button>
                                        <Button
                                            className="app-store-btn w-100 app-store-btn-custom"
                                            onClick={handlePlayStore}
                                        >
                                            <div className="app-store-btn-inner">
                                                <FontAwesomeIcon icon={faGooglePlay as IconProp} className="me-3 app-store-btn-icon" />
                                                <div className='d-flex flex-column text-start'>
                                                    <span className="app-store-btn-small">GET IT ON</span>
                                                    <span className="app-store-btn-bold">Google Play</span>
                                                </div>
                                            </div>
                                        </Button>
                                    </div>
                            </div>
                        </Card>
                    </Col>

                    {/* Contact Us */}
                    <Col lg={6} md={6} className="mb-4">
                        <Card className="ordering-option-card">
                            <div className="card-content text-center">
                                <div className="icon-wrapper">
                                    <FontAwesomeIcon icon={faPhone} className="option-icon" />
                                </div>
                                <h4 className="option-title">Contact Us</h4>
                                <p className="option-description">
                                    Prefer to speak with us directly? Reach out via phone or WhatsApp for personalized service.
                                </p>
                                <div className="contact-buttons">
                                    {/* <Button
                                        className="whatsapp-btn me-2"
                                        onClick={handleWhatsApp}
                                    >
                                        <FontAwesomeIcon icon={faComments} className="me-2" />
                                        WhatsApp
                                    </Button> */}
                                    <Button
                                        className="call-btn"
                                        onClick={handleCallUs}
                                    >
                                        <FontAwesomeIcon icon={faPhone} className="me-2" />
                                        Call Us
                                    </Button>
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

export default HomeRoute;